{
  "REGISTER": {
    "TRY_WOOT": "Sukurti paskyrą",
    "TITLE": "Registras",
    "TESTIMONIAL_HEADER": "Tereikia vieno žingsnio, kad judėtume į priekį",
    "TESTIMONIAL_CONTENT": "Liko vienas žingsnis, kad įtrauktumėte savo klientus, išlaikytumėte juos ir rastumėte naujų.",
    "TERMS_ACCEPT": "Kurdami paskyrą sutinkate su mūsų <a href=\"https://chat.jarabot.com/terms\">T & C</a> ir <a href=\"https://chat.jarabot.com/ privacy-policy\">Privatumo politika</a>",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Naudojimo sąlygos</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Privatumo politika</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Užsiregistruoti su Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Įmonės pavadinimas",
      "PLACEHOLDER": "Enter your company name. eg: Wayne Enterprises",
      "ERROR": "Company name is too short"
    },
    "FULL_NAME": {
      "LABEL": "Pilnas vardas",
      "PLACEHOLDER": "Enter your full name. eg: Bruce Wayne",
      "ERROR": "Full name is too short"
    },
    "EMAIL": {
      "LABEL": "Darbinis el. paštas",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Please enter a valid work email address"
    },
    "PASSWORD": {
      "LABEL": "Slaptažodis",
      "PLACEHOLDER": "Slaptažodis",
      "ERROR": "Password is too short",
      "IS_INVALID_PASSWORD": "Password should contain atleast 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm Password",
      "PLACEHOLDER": "Confirm Password",
      "ERROR": "Password doesnot match"
    },
    "API": {
      "SUCCESS_MESSAGE": "Registracija sėkminga",
      "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
    },
    "SUBMIT": "Sukurti paskyrą",
    "HAVE_AN_ACCOUNT": "Jau turi prisijungimo paskyrą?"
  }
}
